module.exports = __webpack_public_path__ + "img/bn21.fa2c7ba9.png";